import MyPages from "page/user/my-pages/my-pages";
import { connect } from "react-redux";
import { ApplicationState } from "store";
import { getUserName } from "user/store";
import { actionCreators } from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    MyPages_OrderHistory: getResource(state, { key: "MyPages_OrderHistory" }),
    MyPages_OrderdCalendars: getResource(state, {
        key: "MyPages_OrderdCalendars",
    }),
    Admin_Header_Back: getResource(state, { key: "Admin_Header_Back" }),
    userName: getUserName(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPages);
